import get from 'lodash/get';

import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import {
  USERS_USER_SET, USERS_USER_REMOVE, USERS_AUTH_LOGIN_NOTIFICATIONS,
} from 'rebook/apps/users/constants';


export function fetchCurrentUser(onSuccess) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    // fetch the current's user profile details
    await fetchQuery('/api/profile/', { apiVersion: 5, headers: ssr.headers })
      .then(
        ({ data, resp }) => {
          if (resp && (resp.status === 204)) {
            throw Error({ data, resp });
          }
          else if (get(data, 'objects[0].b2b_slug', null)) {
            window.location.href = `https://${data.objects[0].b2b_slug}.${BASE_HOST}`;
          }
          else {
            const userObject = { ...data.objects[0] };
            if (userObject.id && window && window.ga) {
              ga('set', 'dimension1', userObject.id);
              yaMetrikaSetUserID(userObject.id);
            };
            dispatch(setUser(userObject));
            if (onSuccess) {
              onSuccess();
            }
          }
        }
      )
      .catch(
        ({ data, resp, error }) => {
          if (resp && [401, 204].includes(resp.status)) {
            dispatch(removeUser());
          }
          else {
            Raven.captureMessage('failed to authenticated user due to error', {
              level: 'error',
              extra: {
                status: resp ? resp.status : null,
                data,
                error,
              },
            });
            dispatch(NotificationActions.pop(USERS_AUTH_LOGIN_NOTIFICATIONS.ERROR));
          }
        }
      );
  };
}

export function unbindSocialNetwork(provider, socialAuthId) {
  return async(dispatch, getState) => {
    const url = `/api/cb/social/disconnect/${provider}/${socialAuthId}/`;
    const { ssr, user } = getState();

    dispatch({
      type: USERS_USER_SET,
      payload: { ...user, unboundProvider: provider },
    });

    return await fetchQuery(url, { method: 'post', headers: ssr.headers })
      .then(
        () => {
          dispatch(fetchCurrentUser());
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to unbind social network from user', {
            level: 'error',
            extra: {
              status: resp.status,
              data,
            },
          });
        }
      );
  };
}

export function unAuthenticateUser() {
  return (dispatch) => {
    fetchQuery('/api/unauth/', { method: 'post' })
      .then(
        () => {
          dispatch(removeUser());
          if (window && window.ga) {
            ga('set', 'dimension1', 0);
            yaMetrikaSetUserID(0);
          };
          dispatch(NotificationActions.pop(USERS_AUTH_LOGIN_NOTIFICATIONS.LOGOUT));
        }
      )
      .catch(
        ({ data, resp }) => {
          // already unauthenticated? pretend the user successfully logged out
          if (resp.status === 403) {
            dispatch(removeUser());
            dispatch(NotificationActions.pop(USERS_AUTH_LOGIN_NOTIFICATIONS.LOGOUT));
          }
          else {
            Raven.captureMessage('failed to logout user due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                data,
              },
            });
            dispatch(NotificationActions.pop(USERS_AUTH_LOGIN_NOTIFICATIONS.ERROR));
          }
        }
      );
  };
}

export function changeUserEmail(email) {
  return async(dispatch) => {
    const url = '/api/change-email/';
    const bodyParams = {
      apiVersion: 4,
      method: 'post',
      json: { email },
    };
    return await fetchQuery(url, bodyParams)
      .then(
        ({ data }) => {
          dispatch({
            type: USERS_USER_SET,
            payload: { newUserEmail: data.email },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to user email updating', {
            level: 'error',
            extra: {
              status: resp.status,
              data,
            },
          });
          dispatch(NotificationActions.pop(data.email.join()));
        }
      );
  };
}

export function setUser(user) {
  return {
    type: USERS_USER_SET,
    payload: user,
  };
}

export function removeUser() {
  return {
    type: USERS_USER_REMOVE,
  };
}
